/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSecurityHubFindingRecordStatesRequest {
    getFixupPrototypeFunction() { return AwsSecurityHubFindingRecordStatesRequest.fixupPrototype; }

    static newInstance(model: Partial<AwsSecurityHubFindingRecordStatesRequest>): AwsSecurityHubFindingRecordStatesRequest {
        let obj = Object.assign(new AwsSecurityHubFindingRecordStatesRequest(), model);
        AwsSecurityHubFindingRecordStatesRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSecurityHubFindingRecordStatesRequest>): AwsSecurityHubFindingRecordStatesRequest {
        if (!model) return null;
        return AwsSecurityHubFindingRecordStatesRequest.newInstance(<AwsSecurityHubFindingRecordStatesRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSecurityHubFindingRecordStatesRequest) {
        if (!obj) return;

        models.AwsSecurityHubFindingRecordStatesRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSecurityHubFindingRecordStatesRequest): boolean {
        Object.setPrototypeOf(obj, AwsSecurityHubFindingRecordStatesRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Which tenant Id to fetch record states for
     */
    tenant_id: string;

}
